import styled from 'styled-components'
import { desktopBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Container = styled.section`
    padding: 1rem 0 0.5rem;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`

export const OfferWrapper = styled.div`
    display: flex;
    grid-template-columns: repeat(2, 1fr);
    gap: ${props => props.theme.spacing.medium};
    margin-top: 1rem;
`

export const SliderContainer = styled.div`
    margin-top: 1rem;
`
